import { Booking, User } from "@/types";

export function getCertificateUrl(booking: Booking, user: User): string {
  if (process.env.VUE_APP_NODE_ENV === "production") {
    return `https://rdplayincludedproduction.blob.core.windows.net/root/certificates/${user.id}/event-certificate-${booking.event?.id}.pdf`;
  }

  return `https://playincludedstaging.blob.core.windows.net/root/certificates/${user.id}/event-certificate-${booking.event?.id}.pdf`;
}

/**
 * Returns true if the certificate URL should be shown for the booking.
 * Based on event level, type and user attendance.
 * Excludes bookings with payment method "Migration".
 * @param booking
 * @returns
 */
export function shouldShowCertificateUrl(booking: Booking): boolean {
  const levelBookings = ["Certified Facilitator", "Advanced Facilitator", "L1 and L2 Combined"];

  // Exclude bookings with payment method "Migration"
  if(booking.payment_method === "Migration") {
    return false;
  }

  // Check if the user attended the event
  if(!booking.user_attended) {
    return false;
  }

  // Check if the event type is "training"
  if (booking.event!.type !== "training") {
    return false;
  }

  // Check if the event level is one of the specified levels
  if (!levelBookings.includes(booking.event!.level)) {
    return false;
  }

  return true;
}

